import React, { useMemo } from 'react';
import { type Listing } from '@pkgs/api/models';
import { getLocationBreadcrumbString } from '@pkgs/api';
import { Copy } from '@ev-tech/ui-core-components/Copy';

import { useListing } from '@/hooks/queries/useListing';

import styles from './StickyHeader.module.css';

const LocationTextComponent = ({ listing }: { listing: Listing }) => {
  const location = useMemo(() => getLocationBreadcrumbString({ listing, returnAllItems: false }), [listing]);

  return <Copy className={styles.infoLabel} text={location} size="m" />;
};

export const LocationText = () => {
  const {
    data: { listing },
  } = useListing();

  if (!listing) return null;

  return <LocationTextComponent listing={listing} />;
};
